import {
  FACET_ADDED,
  FACET_SHOW_ALL,
  FACET_REMOVED,
  FACET_RESET,
  FACET_SEARCH_WITH_AREA_FILTER,
} from '../action-types/facetActionTypes';

const initialState = {
  facets: [],
  partialFacets: [],
  facetLength: 0,
  showAllFacets: false,
  searchWithAreaFilter: false,
  showAllButtonVisible: false,
};
const SHOW_ALL_BUTTON_VISIBILITY = 250;

const augmentFacets = facets => {
  let len = 0;
  const partialFacets = [];

  if (facets.length > 0) {
    facets.forEach(f => {
      len += f.title.length;
      if (len < SHOW_ALL_BUTTON_VISIBILITY) {
        partialFacets.push(f);
      }
    });
  }
  return {
    facetLength: len,
    partialFacets: partialFacets,
    showAllButtonVisible: facets.length > partialFacets.length,
  };
};

const facetReducer = (state = initialState, action) => {
  switch (action.type) {
    case FACET_ADDED: {
      return {
        ...state,
        facets: action.facets,
        ...augmentFacets(action.facets),
      };
    }
    case FACET_REMOVED: {
      return {
        ...state,
        facets: action.facets,
        ...augmentFacets(action.facets),
      };
    }

    case FACET_SHOW_ALL: {
      return {
        ...state,
        showAllFacets: !state.showAllFacets,
      };
    }

    case FACET_RESET: {
      return {
        ...initialState,
        facets: [],
        partialFacets: [],
        selectedFacets: [],
        showAllFacets: false,
        showAllButtonVisible: false,
      };
    }
    case FACET_SEARCH_WITH_AREA_FILTER: {
      return {
        ...state,
        showAllFacets: false,
        searchWithAreaFilter: true,
      };
    }

    default: {
      return state;
    }
  }
};

export default facetReducer;
